import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { closeFnSet } from './show';
/**
 * 关闭所有通过指令方式打开的对话框
 */

export function clear() {
  closeFnSet.forEach(function (close) {
    close();
  });
}